import React, { useState, useEffect } from 'react'
import { useFormik } from 'formik'
import { Flex, Grid, GridItem, Text } from '@chakra-ui/react'
import { ButtonDotted, InfoCard, TextAreaComtrol } from '../../../UI'
import FamilyMemberCard from './FamilyMemberCard'
import { ClearFormatMoney, FormatMoney } from '../../../../Utils'
import { steepThreeExtraSchema } from '../Schemas'

const StepThree = ({
  refStepThree,
  stepThreeForm,
  setStepThreeForm,
  descriptionsStepThree,
  setDescriptionsStepThree,
  next
}) => {
  const [members, setMembers] = useState([])
  const [totalExpenditure, setTotalExpenditure] = useState(0)

  const initialValues = {
    descriptionsFamilyMembers: ''
  }

  const handleAddMember = () => {
    const memberTemplate = {
      _id: Date.now().toString(),
      memberName: '',
      memberAge: 0,
      memberRelationship: '',
      scholarship: '',
      memberActivity: '',
      memberIncomes: '',
      memberForecast: '',
      /* --- health data --- */
      haveMedicalHistory: false,
      doctorName: '',
      hospitalName: '',
      monthlyExpenditure: '',
      diagnostic: '',
      evolutionTime: '',
      observation: '',
      medicalHistoryName: [],
      medicalHistory: null,
      updated: false
    }
    setMembers([...members, memberTemplate])
  }

  const validateEmptyMember = () => {
    if (members.length > 0) {
      const exists = members.find((item) => item.updated === false)
      return Boolean(exists)
    }
    return false
  }

  const handleDeleteMember = (_id) => {
    const index = members.findIndex((item) => item._id === _id)
    if (index !== -1) {
      const newMembers = [...members]
      newMembers.splice(index, 1)
      setMembers(newMembers)
    }
  }

  const handleUpdateMember = (id, values, isValid = true) => {
    const index = members.findIndex((item) => item._id === id)
    const newMembers = [...members]
    if (index !== -1 && isValid) {
      const updated = {
        _id: id,
        memberName: values.memberName,
        memberAge: values.memberAge,
        memberRelationship: values.memberRelationship,
        scholarship: values.scholarship,
        memberActivity: values.memberActivity,
        memberIncomes: values.memberIncomes,
        memberForecast: values.memberForecast,
        /* --- health data --- */
        haveMedicalHistory: values.haveMedicalHistory,
        doctorName: values.doctorName,
        hospitalName: values.hospitalName,
        monthlyExpenditure: values.monthlyExpenditure,
        diagnostic: values.diagnostic,
        evolutionTime: values.evolutionTime,
        observation: values.observation,
        medicalHistoryName: values.medicalHistoryName,
        medicalHistory: values.medicalHistory,
        state: values.state,
        updated: true
      }

      newMembers.splice(index, 1, updated)
      setMembers(newMembers)
    }
    if (index !== -1 && !isValid) {
      newMembers[index].updated = false
      setMembers(newMembers)
    }
  }

  const formik = useFormik({
    initialValues,
    validateOnMount: false,
    validateOnChange: false,
    validationSchema: steepThreeExtraSchema,
    onSubmit: (values) => {
      if (members.length > 0 && !validateEmptyMember()) {
        const filteredForms = members.filter((item) => item.updated === true)
        setStepThreeForm(filteredForms)
      }
      setDescriptionsStepThree(values)
      next()
    }
  })

  useEffect(() => {
    refStepThree.current = formik.handleSubmit

    if (members.length > 0) {
      const total = members.reduce(
        (acc, item) => acc + Number(ClearFormatMoney(item.monthlyExpenditure)),
        0
      )
      setTotalExpenditure(FormatMoney(total))
    }
  }, [members])

  useEffect(() => {
    if (stepThreeForm.length > 0) {
      setMembers(stepThreeForm)
    }
    formik.setValues({
      ...formik.values,
      descriptionsFamilyMembers:
        descriptionsStepThree?.descriptionsFamilyMembers || ''
    })
  }, [stepThreeForm, descriptionsStepThree])

  return (
    <Grid
      templateColumns={{
        lg: 'repeat(1, 1fr)'
      }}
      gap={2}
    >
      <GridItem>
        <Text fontWeight={700} color={'green.500'} fontSize={'xl'}>
          Antecedentes del grupo familiar
        </Text>
        {members.length > 0 && (
          <Flex justify={'flex-end'}>
            <InfoCard px={10}>
              <Text fontWeight={700}>
                Subtotal gastos médicos grupo familiar
              </Text>
              <Text fontWeight={700} fontSize={'2xl'}>
                $ {totalExpenditure}
              </Text>
            </InfoCard>
          </Flex>
        )}
        {members.map((item) => (
          <FamilyMemberCard
            key={item._id}
            _id={item._id}
            members={members}
            member={item}
            handleUpdateMember={handleUpdateMember}
            onClick={(_id) => handleDeleteMember(_id)}
          />
        ))}
        <ButtonDotted
          text={'Añadir integrante'}
          onClick={handleAddMember}
          disabled={validateEmptyMember()}
        />
      </GridItem>
      <GridItem>
        <TextAreaComtrol
          id={'descriptionsFamilyMembers'}
          label={'Descripción de situación específica del grupo familiar'}
          isRequired={false}
          value={formik.values.descriptionsFamilyMembers}
          onChange={formik.handleChange}
          error={Boolean(formik.errors.descriptionsFamilyMembers)}
          errorText={formik.errors.descriptionsFamilyMembers}
        />
      </GridItem>
    </Grid>
  )
}

export default StepThree
